import 'swiper/swiper-bundle.css';
import './app.css';

import {createRoot, hydrateRoot} from 'react-dom/client';
import {CommonProvider} from '@common/core/common-provider';
import {rootEl} from '@common/core/root-el';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
// import {UserLink} from '@app/profile/user-link';
// import {UserProfile} from '@app/profile/user-profile';
// import {LandingPageContent} from '@app/landing-page/landing-page-content';
import {BrowserRouter} from 'react-router-dom';
import {AppRoutes} from '@app/app-routes';

// todo: don't include title description in homepage channel, except for slider channel, skip other not needed data as well to reduce payload size
// todo: slice description on php side, instead of client in channel slider

declare module '@common/http/value-lists' {
  interface FetchValueListsResponse {
    titleFilterLanguages: {value: string; name: string}[];
    genres: {value: string; name: string}[];
    keywords: {value: string; name: string}[];
    titleFilterAgeRatings: {value: string; name: string}[];
    tmdbLanguages: {name: string; code: string}[];
    tmdbDepartments: {department: string; jobs: string[]}[];
  }
}

declare module '@common/core/bootstrap-data/bootstrap-data' {
  interface BootstrapData {
    loaders?: {
      // newsArticlePage?: GetNewsArticleResponse;
      customPage?: any;
      landingPage?: {
      };
    };
  }
}

declare module '@common/core/settings/settings' {
  interface Settings {
    homepage?: {

    };



    content: {
      search_provider: 'local';
    };
  }
}



const data = getBootstrapData();

const app = (
  <BrowserRouter basename={data.settings.html_base_uri}>
    <CommonProvider>
      <AppRoutes />
    </CommonProvider>
  </BrowserRouter>
);

if (data.rendered_ssr) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
